define('view/disclosure/modals/confirm.review.completion.modal',['require','exports','module','underscore','uikit/uikit','blockit','fukit','backbone.radio','datakit/util/url'],function(require, exports, module) {
  //prettier-ignore
  var _                             = require('underscore'),
      UIKit                         = require('uikit/uikit'),
      BlocKit                       = require('blockit'),
      Factory                       = require('fukit').Factory,
      Radio                         = require('backbone.radio'),
      url                           = require('datakit/util/url'),
      disclosureConfirmationChannel = Radio.channel('disclosureConfirmationChannel');

  var ConfirmReviewCompletionModal = UIKit.Modal2.extend({
    className: 'ui modal confirmation',
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      closable: true,
    }),
    header: {
      type: UIKit.Modal2.HeaderView,
      text: 'Confirm that your review is complete',
    },
    content: {
      type: UIKit.Modal2.ContentView,
      components: [
        {
          type: UIKit.Text,
          text:
            'Would you like to confirm your review? You will only be able to perform this confirmation once. You must leave a note on your review to continue.',
        },
        {
          type: BlocKit.FormContainerView,
          basic: true,
          components: [
            {
              name: 'commentInput',
              content: {
                type: UIKit.Input,
                placeholder: 'Add required comment here',
                rowCount: 4,
                multiLine: true,
                behaviors: {
                  //check if input value exists and contain whitespace
                  verifyTextEnableButton: {
                    behaviorClass: Mn.Behavior.extend({
                      onChangeValue: function() {
                        var comment = this.view.getOption('value');
                        var isButtonDisabled;
                        if (comment && /\S/.test(comment)) {
                          isButtonDisabled = false;
                        } else {
                          isButtonDisabled = true;
                        }
                        disclosureConfirmationChannel.trigger('input:validation', isButtonDisabled);
                        disclosureConfirmationChannel.trigger('comment:text', comment);
                      },
                    }),
                  },
                },
              },
            },
          ],
        },
      ],
    },
    actions: {
      components: [
        {
          type: UIKit.Modal2.DenyButtonView,
          text: 'Cancel',
        },
        {
          type: UIKit.Modal2.ConfirmButtonView,
          text: 'Confirm Review',
          icon: '',
          color: 'primary',
          disabled: true,
          behaviors: {
            //disable the button initially until text is entered
            toggleConfirmReviewButtonBehavior: {
              behaviorClass: Mn.Behavior.extend({
                onRender: function() {
                  this.listenTo(disclosureConfirmationChannel, 'input:validation', function(isButtonDisabled) {
                    if (this.view.getOption('disabled') !== isButtonDisabled) {
                      this.view.disabled = isButtonDisabled;
                      this.view.render();
                    }
                  });
                },
              }),
            },

            submitCommentBehavior: {
              behaviorClass: Mn.Behavior.extend({
                onFirstBeforeRender: function() {
                  var commentJSON;
                  this.listenTo(disclosureConfirmationChannel, 'comment:text', function(comment) {
                    commentJSON = { message: comment };
                  });

                  this.listenTo(this.view, 'press', function() {
                    var workflowTaskModel = Radio.request('AppKit.resourceService', 'resource', 'workflowTaskModel');
                    var taskId = workflowTaskModel.get('id');
                    var disclosureCommentModel = Radio.request(
                      'AppKit.resourceService',
                      'resource',
                      'disclosureCommentModel'
                    );
                    disclosureCommentModel
                      .save(commentJSON, {
                        url: url.template('/api/v1/coi-workflow/runtime/tasks/:taskId/comments', { taskId: taskId }),
                      });
                  });
                },
              }),
            },

            submitConfirmationMarkCompleteBehavior: {
              behaviorClass: Mn.Behavior.extend({
                onFirstBeforeRender: function() {
                  var workflowTaskModel = Radio.request('AppKit.resourceService', 'resource', 'workflowTaskModel');
                  var taskJSON = [
                    {
                      name: 'disclosureConfirmReview',
                      value: 'CONFIRM',
                      type: 'string',
                    },
                  ];
                  this.listenTo(this.view, 'press', function() {
                    workflowTaskModel.completeTask(taskJSON);
                  });
                },
                onClose: function() {
                  this.stopListening();
                },
              }),
            },
          },
        },
      ],
    },
  });

  module.exports = ConfirmReviewCompletionModal;
});

